import React, { useState } from "react";
import { ReactComponent as XIcon } from "../../../assets/svg/x.svg";
import styles from "./ProjectDetails.module.scss";
import { useHistory } from "react-router-dom";
import DefaultImage from "../../../assets/images/fondoObraPrivada.jpg";
import { ReactComponent as ArrowRightIcon } from "../../../assets/svg/arrowRightIcon.svg"
import { ReactComponent as TrashIcon } from "../../../assets/svg/trashIcon.svg";
import { deleteProyecto } from "../../../store/actions";
import { connect } from "react-redux"

const ProjectDetails = ({ project, deleteProyecto }) => {
    const [showProject, setShowProject] = useState(false);

    const history = useHistory();

    const handleShowProject = () => {
        setShowProject(!showProject);
    }

    const coverImage = project?.proyecto_images[0]?.image || DefaultImage;

    //Formateamos fechas
    const formatDate = (date) => {
        if (date && typeof date === "string") {
            const fecha = new Date(date);
            return fecha.toLocaleDateString();
        }
        return "";
    };

    const handleRedirectToProject = () => {
        history.push(`/proyectosprivados/${project.id}`);
    };

    const handleDeleteProject = () => {
        deleteProyecto(parseInt(project.id))
        setTimeout(() => {
            setShowProject(false)
        }, 1000)
    }

    return (
        project?.type === "PRIVATE" && (
            <>
                <div className={styles.container}>
                    <div className={styles.container_image}>
                        <img className={styles.container_image_img} src={coverImage} alt="proyecto" />
                    </div>
                    <div className={styles.container_info}>
                        <div className={styles.container_info_text} onClick={() => handleRedirectToProject()}>
                            <p>{project?.name}</p>
                            <p>{project?.description}</p>
                        </div>
                        <div className={styles.container_info_button} onClick={() => handleShowProject()}>
                            <div >Ver más</div>
                        </div>
                    </div>
                </div>
                {showProject && (
                    <div className={styles.container_portfolio}>
                        <div className={styles.container_portfolio_container}>
                            <div className={styles.container_portfolio_headerContainer}>
                                <div className={styles.container_portfolio_delete} onClick={() => handleDeleteProject()}>
                                  
                                    <TrashIcon width={20} height={20}/>
                                </div>
                                <div className={styles.container_portfolio_editButton} onClick={() => handleRedirectToProject()}>
                                    Editar
                                    <ArrowRightIcon height={10} width={10} />
                                </div>
                                <div className={styles.container_portfolio_close} onClick={() => handleShowProject()}>
                                    <XIcon width={18} height={18} />
                                </div>
                            </div>
                            <div className={styles.container_portfolio_container_content}>
                                <div className={styles.container_portfolio_info}>
                                    <h2 className={styles.container_portfolio_info_title}>{project?.name}</h2>
                                    <div className={styles.container_portfolio_info_text}>
                                        <h3 className={styles.container_portfolio_info_subTitle}>Descripción</h3>
                                        <p className={styles.container_portfolio_info_subTitle_txt}>{project?.description}</p>
                                    </div>
                                    <div className={styles.container_portfolio_info_boxes}>
                                        <div className={styles.container_portfolio_info_boxes_zone}>
                                            <h3 className={styles.container_portfolio_info_subTitle}>Zona</h3>
                                            <p className={styles.container_portfolio_info_subTitle_txt}>{project?.zone}</p>
                                        </div>
                                        <div className={styles.container_portfolio_info_boxes_start}>
                                            <h3 className={styles.container_portfolio_info_subTitle}>Inicio</h3>
                                            <p className={styles.container_portfolio_info_subTitle_txt}>{formatDate(project?.startDate)}</p>
                                        </div>
                                        <div className={styles.container_portfolio_info_boxes_end}>
                                            <h3 className={styles.container_portfolio_info_subTitle}>Fin</h3>
                                            <p className={styles.container_portfolio_info_subTitle_txt}>{formatDate(project?.endDate)}</p>
                                        </div>
                                    </div>

                                </div>
                                <div className={styles.container_portfolio_images}>
                                    {project?.proyecto_images.map((image, index) => (
                                        <div key={index} className={styles.container_portfolio_images_item}>
                                            <img className={styles.container_portfolio_images_item_img} src={image.image} alt="portfolio" />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </>
        )
    );
};

const mapStateToProps = (state) => {
    return {
        
    }
}

export default connect(mapStateToProps,{deleteProyecto})(ProjectDetails);